import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowRight, Phone } from 'lucide-react';

const CTASection = ({ 
  title = "Klaar om uw bedrijf te laten groeien?",
  subtitle = "Plan vandaag nog een gratis kennismakingsgesprek en ontdek hoe wij u kunnen helpen.",
  primaryButtonText = "Plan een Demo",
  secondaryButtonText = "Neem Contact Op",
  showPhone = true
}) => {
  return (
    <section className="py-20 bg-gradient-to-br from-blue-700 via-blue-600 to-blue-800 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl transform -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl transform translate-x-1/2 translate-y-1/2"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
            {title}
          </h2>
          <p className="text-xl text-blue-100 mb-10 max-w-2xl mx-auto">
            {subtitle}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link to="/contact">
              <Button 
                size="lg" 
                className="bg-white text-blue-700 hover:bg-gray-100 px-8 py-6 text-lg font-semibold rounded-lg shadow-xl hover:shadow-2xl transition-all duration-300 group"
              >
                {primaryButtonText}
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
              </Button>
            </Link>

            {showPhone && (
              <a href="tel:0638823471">
                <Button 
                  size="lg" 
                  variant="outline"
                  className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-blue-700 px-8 py-6 text-lg font-semibold rounded-lg transition-all duration-300"
                >
                  <Phone className="mr-2 w-5 h-5" />
                  06 3882 3471
                </Button>
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
